<template>
  <div class="zyc-table-screen">
    <label>{{ label }}</label>
    <div class="zyc-table-screen-content" :id="id" :style="contentStyle">
      <div v-if="offsetHeight > rowHeight && isHide" :class="moreActive?'zyc-table-screen-content-more':'zyc-table-screen-content-more-active'" @click="moreClick">更多 <i class="el-icon-arrow-up"></i></div>
      <div :class="offsetHeight > rowHeight && isHide ? 'showMore':''">
        <slot></slot>
      </div>
    </div>
    <div style="clear:both"></div>
  </div>
</template>
<script>
  /**
  * 筛选容器
  */
  export default {
    name: 'zycTableScreen',
    props: {
      label: {
        type: String,
        default: ''
      },
      rowHeight: {
        type: Number,
        default: 35
      },
      isHide: {
        type: Boolean,
        default: true
      },
      hideRows: {
        type: Number,
        default: 1
      }
    },
    model: {
    },
    watch: {
    },
    data() {
      return {
        id: Math.random().toString(36).slice(2),
        contentStyle: {},
        offsetWidth: 0,
        offsetHeight: 0,
        moreActive: false,
      }
    },
    mounted() {
      const el = document.getElementById(this.id)
      this.offsetHeight = el.scrollHeight
    },
    created() {
      this.$nextTick(() => {
        if (this.isHide) {
          this.moreActive = true
        }
        this.moreClick()
        window.addEventListener('resize', this.onresize)
      })
    },
    methods: {
      onresize(event) {
        this.$nextTick(() => {
          const el = document.getElementById(this.id)
          if (el) {
            this.offsetHeight = el.scrollHeight
          }
        })
      },
      reSize: function () {
        this.onresize()
        this.$forceUpdate()
      },
      init: function () {
        if (this.isHide) {
          this.contentStyle = {
            height: this.rowHeight * this.hideRows + 'px',
            overflow: 'hidden',
            margin: '0 0 0px 0',
            transition: '0.4s linear'
          }
        }
      },
      moreClick: function () {
        if (this.isHide) {
          if (this.moreActive) {
            this.moreActive = false
            this.contentStyle = {
              height: this.rowHeight * this.hideRows + 'px',
              overflow: 'hidden',
              margin: '0 0 0px 0',
              transition: '0.4s linear'
            }
          } else {
            this.moreActive = true
            this.contentStyle = {
              height: this.offsetHeight + 'px',
              overflow: 'hidden',
              margin: '0 0 0px 0',
              transition: '0.4s linear'
            }
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/zyc/container/screenContainer.vue